import { render, staticRenderFns } from "./EvaluationButtons.vue?vue&type=template&id=5b7b5e04&scoped=true"
import script from "./EvaluationButtons.vue?vue&type=script&lang=js"
export * from "./EvaluationButtons.vue?vue&type=script&lang=js"
import style0 from "./EvaluationButtons.vue?vue&type=style&index=0&id=5b7b5e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b5e04",
  null
  
)

export default component.exports